import { gql } from '@apollo/client';

export const CRASH_REPORTS_ORG_FILTER_OPTIONS_GQL = gql`
  query CrashReportsOrgFilterOptionsQuery {
    organization(where: { deleted_at: { _is_null: true } }, order_by: { name: asc }) {
      id
      name
    }
  }
`;

export const CRASH_REPORTS_MONITOR_GQL = gql`
  query CrashReportsMonitorQuery(
    $from: bigint!
    $to: bigint!
    $faultCode: Int!
    $deviceWhere: device_bool_exp!
  ) {
    fault(
      where: {
        code: { _eq: $faultCode }
        started_at: { _gte: $from, _lte: $to }
        device: $deviceWhere
      }
      order_by: { started_at: asc }
    ) {
      id
      started_at
      details
      device {
        id
        serial
        device_assignments(
          where: { ended_at: { _is_null: true }, deleted_at: { _is_null: true } }
          order_by: { started_at: desc }
          limit: 1
        ) {
          feed_line {
            id
            name
            farm {
              id
              name
              organization {
                id
                name
              }
            }
          }
        }
      }
    }
  }
`;

